import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { memo } from "react";
export const ShareButton = /*#__PURE__*/ memo((param)=>{
    let { dataTestId, ...props } = param;
    return /*#__PURE__*/ _jsx(Button, {
        appearance: "outline",
        color: "grey",
        "data-testid": dataTestId,
        size: "medium",
        ...props,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex items-center gap-1 text-12",
            children: [
                /*#__PURE__*/ _jsx(Link, {
                    className: "size-4"
                }),
                "Share"
            ]
        })
    });
});
ShareButton.displayName = "ShareButton";
